import { render, staticRenderFns } from "./BottomPopup.vue?vue&type=template&id=5acdf9e6&lang=html"
import script from "./BottomPopup.vue?vue&type=script&lang=js"
export * from "./BottomPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports